import DonutChartWidget from "./DonutChartWidget";
import type { InboundCallStatusDistributionData } from "@/lib/axios/api/widgets.api";
import React from "react";

const COLORS = ['#23407A', '#00FEC1', '#6D8596'];
const DARK_COLORS = ['#1681F6', '#00FEC1', '#6D8596'];

interface InboundCallStatusDistributionWidgetProps {
  data: InboundCallStatusDistributionData | null;
  loading?: boolean;
  error?: string | null;
  onClick?: (filters: { [key: string]: string[] }) => void;
}

const InboundCallStatusDistributionWidget: React.FC<InboundCallStatusDistributionWidgetProps> = ({ data, loading, error, onClick }) => {
  const answered = data?.answeredCall ?? 0;
  const missed = data?.missedCall ?? 0;
  const abandoned = data?.totalAbandonedCalls ?? 0;
  const total = data?.total ?? answered + missed + abandoned;

  const donutData = [
    { name: 'Answered', value: answered },
    { name: 'Missed', value: missed },
    { name: 'Abandoned', value: abandoned },
  ];

  const handleSegmentClick = (segmentName: string, value: number) => {
    if (onClick && value > 0) {
      onClick({ callStatus: [segmentName] });
    }
  };

  return (
    <DonutChartWidget
      title="Inbound Call Status Distribution"
      tooltipDescription="The distribution of inbound calls status within the given time."
      data={donutData}
      colors={COLORS}
      darkColors={DARK_COLORS}
      loading={loading}
      error={error}
      onSegmentClick={onClick ? handleSegmentClick : undefined}
      legendVerticalAlign="middle"
      total={total}
    />
  );
};

export default InboundCallStatusDistributionWidget;
